import { cn } from '@/lib/cn';
import { inicialesDe } from '@/lib/negocio';

/** El sello del negocio: sus iniciales en un cuadro de esquinas redondas. Se lee con el nombre entero. */
export function Sello({ nombre, grande = false }: { nombre: string; grande?: boolean }) {
  return (
    <span
      role="img"
      aria-label={nombre}
      className={cn(
        'grid shrink-0 place-items-center bg-brand-800 font-bold tracking-wide text-white',
        // 21-oct, macOS 27: en la barra lateral mide 28 (como un ícono de app de la barra), radio 7.
        grande ? 'h-14 w-14 rounded-2xl text-lg' : 'h-7 w-7 rounded-[7px] text-[11px]',
      )}
    >
      {inicialesDe(nombre)}
    </span>
  );
}
